import { TieredMenu } from "primereact/tieredmenu";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sideBarItems = useMemo(
    () => [
      {
        label: "Списък",
        icon: "pi pi-list",
        command: () => {
          navigate("/students");
        },
        className: pathname === "/students" ? "p-focus" : "",
      },
      {
        label: "Записване от КСК",
        icon: "pi pi-user-plus",
        command: () => {
          navigate("/students/enrollment");
        },
        className: pathname === "/students/enrollment" ? "p-focus" : "",
      },
      {
        label: "Ръчно записване",
        icon: "pi pi-pencil",
        command: () => {
          navigate("/students/create");
        },
      },
      {
        label: "Справки",
        icon: "pi pi-receipt",
        items: [
          {
            label: "Платежни нареждания",
            command: () => {
              navigate("/students/paymentFiles");
            },
          },
          {
            label: "Заявления за общежитие",
            command: () => {
              navigate("/students/reports/studentDormitoryApplications");
            },
          },
          {
            label: "Записани студенти",
            command: () => {
              navigate("/students/reports/enrolledStudents");
            },
          },
          {
            label: "Неположени изпити",
            command: () => {
              navigate("/students/reports/notTakenExams");
            },
          },
          {
            label: "Брой студенти по групи",
            command: () => {
              navigate("/students/reports/studentCountsGrouped");
            },
          },
          {
            label: "Среден успех по групи",
            command: () => {
              navigate("/students/reports/groupAverageGrade");
            },
          },
          {
            label: "Оценки и заверки на студенти по групи",
            command: () => {
              navigate("/students/reports/groupGrades");
            },
          },
        ],
      },
    ],
    [pathname],
  );

  return <TieredMenu model={sideBarItems} breakpoint="767px" className="w-full" />;
};

export default Sidebar;
